import React from "react";
import "./ButtonLoader.scss";

type Props = {
  /** Diameter in px. */
  size?: number;
  className?: string;
};

/** Compact spinner for use inside save / action buttons. */
const ButtonLoader: React.FC<Props> = ({ size = 14, className = "" }) => (
  <span
    className={`button-loader ${className}`.trim()}
    style={{ width: size, height: size }}
    aria-hidden
  />
);

export default ButtonLoader;
